import React, { useCallback, useEffect } from 'react';
import { useRegistrarObtenerPago } from '../../hooks/powerpay';
import { DetalleConfirmacionPago } from './DetalleConfirmacionPago';

export const ConfirmacionPagoPowerpay = ({mostrarCargando}) => {  

  const { data, isLoading, hasError } = useRegistrarObtenerPago();  
  
  const handleCargando = useCallback(mostrarCargando, [])

  useEffect(() => {
    handleCargando(isLoading);
  }, [isLoading, handleCargando])
  
  useEffect(() => {
    if(hasError){
      handleCargando(true);
      alert("Error al obtener el pago");
    }
  }, [hasError, handleCargando])
    
  
  return (
    <>
      {data && <DetalleConfirmacionPago data={data} />}
    </>
  )
}
